var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6 0a1 1 0 0 1 1 1v1h4V1a1 1 0 1 1 2 0v1h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h2V1a1 1 0 0 1 1-1ZM5 4H3a1 1 0 0 0-1 1v2h14V5a1 1 0 0 0-1-1h-2v1a1 1 0 1 1-2 0V4H7v1a1 1 0 0 1-2 0V4Zm11 5H2v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9Z",
  clipRule: "evenodd"
})));
export default SvgIconCalendar;